import { useRef } from 'react';
import { getDuringSeconds, tracker, assign, dayjsUtils } from '~/utils';

interface IExtObj {
    [key: string]: string | number;
}

interface ITrackerFlow {
    process: string;
    processConf?: IExtObj;
}

/**
 * 用于数据流埋点的自定义Hook
 *
 * @param props
 */
const useTrackerFlow = (props: ITrackerFlow) => {
    const { process, processConf = {} } = props;
    const startTime = useRef<Date>();

    const startFlow = () => {
        startTime.current = new Date();
    };

    const endFlow = (addOnConf?: IExtObj) => {
        if (!startTime.current) {
            return;
        }
        tracker(
            {
                name: process,
                type: 'process',
                p_s: startTime.current.getTime(),
                p_d: getDuringSeconds(dayjsUtils.getNow(), dayjsUtils.dayjs(startTime.current))
            },
            assign(processConf, addOnConf)
        );
        startTime.current = undefined;
    };

    return [startFlow, endFlow] as const;
};

export default useTrackerFlow;
